function Imprint() {
  return (
    <section id="impressum" className="section legal">
      <div className="container narrow">
        <h2>Imprint</h2>

        <h3>Information pursuant to § 5 TMG</h3>
        <p>
          Ulrich &amp; Hellenbrand GbR
          <br />
          Alfred-Delp-Straße 12a
          <br />
          67433 Neustadt
        </p>

        <h3>Responsible for content (according to § 55 para. 2 RStV)</h3>
        <p>Ulrich &amp; Hellenbrand GbR</p>

        <h3>Represented by</h3>
        <p>
          Kai Ulrich
          <br />
          Sebastian Hellenbrand
        </p>

        <h3>Contact</h3>
        <p>
          E-mail:{" "}
          <a href="mailto:info@present-planner.com">info@present-planner.com</a>
        </p>

        <h3>Disclaimer</h3>
        <h4>Liability for content</h4>
        <p>
          The contents of our pages were created with the greatest care.
          However, we cannot guarantee the correctness, completeness and
          up-to-dateness of the content.
        </p>

        <h3>Copyright</h3>
        <p>
          The content and works created by the site operators on these pages are
          subject to German copyright law. Duplication, processing,
          distribution, and any kind of exploitation outside the limits of
          copyright require the written consent of the respective author or
          creator.
        </p>

        <h3>Privacy</h3>
        <p>
          Information on data protection can be found in our privacy policy.
        </p>
      </div>
    </section>
  );
}

export default Imprint;
